import React from 'react';

export default function FeatureStatus( { selected, clearAll, clearAllMessage, noneSelectedMessage, selectedMessage } ) {
    return (
        <div className="flex justify-between items-center" style={{borderBottom: '1px solid #dddddd'}}>
            {selected.length ? (
                <>
                    <span className="text-md w-auto p-2 text-gray-800">{selectedMessage ||  selected.length + ' selected'}</span>
                    <span className="text-md w-auto p-2 text-gray-600 hover:text-purple-500 focus:border-purple-500" onClick={clearAll}>{clearAllMessage || "Clear All"}</span>
                </>
            )
            :
            (
                <>
                    <span className="text-md w-auto p-2 text-gray-800">{noneSelectedMessage || "None selected"}</span>
                    <span>{" "}</span>
                </>
            )
        }
        </div>
    )
}